"use strict";
var game_ts_1 = require("./game.ts");
var team_ts_1 = require("./team.ts");
var goal_ts_1 = require("./goal.ts");
var player_ts_1 = require("./player.ts");
var Comp = (function () {
    function Comp(id, season, grade, games, teams, goals, players) {
        this.id = id;
        this.season = season;
        this.grade = grade;
        this.teamLookup = {}; //id to team. (Key is a number really)
        this.gameLookup = {}; //id to game. (Key is a number really)
        this.playerLookup = {}; // id to player
        var that = this;
        this.teams = _.map(teams, function (t) {
            return new team_ts_1.Team(t["id"], t["name"], t["isPlaceholder"], t["club"]);
        });
        _.forEach(this.teams, function (t) {
            that.teamLookup["" + t.id] = t;
        });
        this.players = _.map(players, function (p) {
            var newPlayer = new player_ts_1.Player(p["id"], p["name"], p["affiliateNumber"], p["isCore"]);
            that.playerLookup["" + newPlayer.id] = newPlayer;
            var t = that.teamLookup["" + p["team"]];
            if (t)
                t.addPlayer(newPlayer);
            return newPlayer;
        });
        var lastGame;
        this.games = _.map(games, function (g) {
            var newGame = that.createGame(that, g);
            var isFirstGame = (!lastGame || lastGame.date !== newGame.date);
            newGame.isFirstGame = isFirstGame;
            lastGame = newGame;
            return newGame;
        });
        _.forEach(this.games, function (g) {
            that.gameLookup["" + g.id] = g;
        });
        this.goals = _.map(goals, function (g) {
            return new goal_ts_1.Goal(g["id"], g["team"], g["game"], g["player"], g["time"], g["gameState"]);
        });
    }
    Comp.prototype.getLadder = function () {
        var validGames = _.filter(this.games, { state: 4 });
        var ladder = [];
        _.forEach(_.filter(this.teams, { isPlaceholder: 0 }), function (t) {
            var scores = {
                team: t,
                played: 0,
                wins: 0,
                losses: 0,
                draws: 0,
                byes: 0,
                goalsFor: 0,
                goalsAgainst: 0
            };
            var filteredGame = _.filter(validGames, { t1: t }).concat(_.filter(validGames, { t2: t }));
            _.forEach(filteredGame, function (g) {
                if (g.isBye) {
                    scores.byes++;
                    return;
                }
                scores.played++;
                var gf = g.t1Score(), ga = g.t2Score();
                if (g.t2 === t) {
                    gf = g.t2Score();
                    ga = g.t1Score();
                }
                if (gf > ga)
                    scores.wins++;
                else if (gf < ga)
                    scores.losses++;
                else if (gf === ga)
                    scores.draws++;
                scores.goalsFor += gf;
                scores.goalsAgainst += ga;
            });
            scores["points"] = (scores.wins * 4) + (scores.draws * 2) + (scores.byes * 4);
            scores["percent"] = (scores.goalsFor / Math.max(scores.goalsAgainst, 1)) * 100;
            scores["percent"] = scores["percent"].toFixed(2);
            ladder.push(scores);
        });
        ladder = _.orderBy(ladder, ["points", "percent"], ["desc", "desc"]);
        return ladder;
    };
    Comp.prototype.createGame = function (that, g) {
        var t1Players = [], t2Players = [];
        if (g["t1AssignedPlayers"] !== null && g["t1AssignedPlayers"] !== undefined)
            t1Players = _.map(g["t1AssignedPlayers"].split(","), function (pId) {
                return that.playerLookup["" + pId];
            });
        if (g["t2AssignedPlayers"] !== null && g["t2AssignedPlayers"] !== undefined)
            t2Players = _.map(g["t2AssignedPlayers"].split(","), function (pId) {
                return that.playerLookup["" + pId];
            });
        return new game_ts_1.Game(g["id"], that.teamLookup[g["t1"]], that.teamLookup[g["t2"]], new Date(g["start"]), g["court"], g["isBye"], g["round"], g["t1GAScore"], g["t1GSScore"], g["t2GAScore"], g["t2GSScore"], g["gameState"], t1Players, t2Players);
    };
    Comp.prototype.updateGame = function (gameJson) {
        var game = this.createGame(this, gameJson);
        var oldGame = this.gameLookup[game.id];
        if (oldGame === undefined) {
            console.error("Game not found can't update");
            return;
        }
        // update isFirstGame.
        game.isFirstGame = oldGame.isFirstGame;
        // update the game.
        this.gameLookup[game.id] = game;
        var index = _.indexOf(this.games, _.find(this.games, { id: game.id }));
        this.games.splice(index, 1, game);
    };
    return Comp;
}());
exports.Comp = Comp;



/*****************
 ** WEBPACK FOOTER
 ** ./src/comp.ts
 ** module id = 57
 ** module chunks = 1
 **/